// extracted by mini-css-extract-plugin
export default {"candidateDetailsContainer":"CandidateDetails-index__candidateDetailsContainer--pNFIq"};